// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 90%;
    width: 20%;
    background-color: white;
    margin-top: 50px;
    right: 5%;
    padding: 1.5rem;
    font-family: "PlusJakartaSans";
    border-radius: 1rem;
    box-shadow: 1px 2px 9px rgb(219, 219, 219);
    position: absolute;
    z-index: 100;
}
.notification-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width:100%;
    font-weight: 600;
    margin-bottom:2rem;
}
.notification-content{
    display: flex;
    flex-direction:column;
    width:100%;
    overflow-y: scroll;
}
.content-header{
    display: flex;
    align-items: center;
    gap: 50px;
    width: 100%;
    margin-bottom: 1rem;
    font-size: small;
    position: absolute;
    background-color: white;
}
.notification-main{
    display: flex;
    flex-direction:column;
    align-items: center;
    width:100%;
    margin-top: 40px;
}
.single-notification{
    display: flex;
    align-items: center;
    justify-content: center;
    width:100%;
    padding-top: 1rem;
    padding-bottom:1rem;
    border-radius: 0.25rem;
    border: 1px solid rgb(223, 227, 232);
    margin-bottom:1rem;
    font-size: small;
}
.single-notification:hover{
    background-color:rgb(236, 236, 254) ;
}
.read{
    background-color: rgb(236, 236, 254);
}
.incident-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.mark-read-btn{
    border: none;
    background-color: transparent;
    color:rgb(64, 64, 242);
}
.read-icon-container{
    display: flex;
    align-items: center;
    justify-content: center;
    width:10%;
    height: 100%;
    /* padding-left: 0.5rem;
    padding-right: 0.5rem;
    margin-right: 1rem;; */
}
.read-icon{
    color:rgb(64, 64, 242);
    width:0.5rem;
}
.not{
    display: none;
}
.incident-container{
    width:85%;
    text-align: left;
}
.no-notfication-container{
    display:flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content:center;
}
.no-notification-img{
    width:12.125rem;
    height:10.75rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/report/components/Notification/Notification.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ;;0BAEsB;AAC1B;AACA;IACI,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,eAAe;AACnB","sourcesContent":[".notification-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    height: 90%;\r\n    width: 20%;\r\n    background-color: white;\r\n    margin-top: 50px;\r\n    right: 5%;\r\n    padding: 1.5rem;\r\n    font-family: \"PlusJakartaSans\";\r\n    border-radius: 1rem;\r\n    box-shadow: 1px 2px 9px rgb(219, 219, 219);\r\n    position: absolute;\r\n    z-index: 100;\r\n}\r\n.notification-header{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width:100%;\r\n    font-weight: 600;\r\n    margin-bottom:2rem;\r\n}\r\n.notification-content{\r\n    display: flex;\r\n    flex-direction:column;\r\n    width:100%;\r\n    overflow-y: scroll;\r\n}\r\n.content-header{\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 50px;\r\n    width: 100%;\r\n    margin-bottom: 1rem;\r\n    font-size: small;\r\n    position: absolute;\r\n    background-color: white;\r\n}\r\n.notification-main{\r\n    display: flex;\r\n    flex-direction:column;\r\n    align-items: center;\r\n    width:100%;\r\n    margin-top: 40px;\r\n}\r\n.single-notification{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width:100%;\r\n    padding-top: 1rem;\r\n    padding-bottom:1rem;\r\n    border-radius: 0.25rem;\r\n    border: 1px solid rgb(223, 227, 232);\r\n    margin-bottom:1rem;\r\n    font-size: small;\r\n}\r\n.single-notification:hover{\r\n    background-color:rgb(236, 236, 254) ;\r\n}\r\n.read{\r\n    background-color: rgb(236, 236, 254);\r\n}\r\n.incident-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n}\r\n.mark-read-btn{\r\n    border: none;\r\n    background-color: transparent;\r\n    color:rgb(64, 64, 242);\r\n}\r\n.read-icon-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width:10%;\r\n    height: 100%;\r\n    /* padding-left: 0.5rem;\r\n    padding-right: 0.5rem;\r\n    margin-right: 1rem;; */\r\n}\r\n.read-icon{\r\n    color:rgb(64, 64, 242);\r\n    width:0.5rem;\r\n}\r\n.not{\r\n    display: none;\r\n}\r\n.incident-container{\r\n    width:85%;\r\n    text-align: left;\r\n}\r\n.no-notfication-container{\r\n    display:flex;\r\n    height: 100%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content:center;\r\n}\r\n.no-notification-img{\r\n    width:12.125rem;\r\n    height:10.75rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
